module.exports = __webpack_public_path__ + "img/5_5.16ee4333.png";